import AdminNetwork from "./Admin/AdminNetwork";
import AgentNetwork from "./Agent/AgentNetwork";
import { isFieldAgent } from "../../utils/roleDetection";

const Network = () => {
	const stored = localStorage.getItem("loggedin_data");
	const user = stored ? JSON.parse(stored) : null;
	const roles = Array.isArray(user?.roles) ? user.roles : [];
	const isAgent = isFieldAgent(roles);

	return isAgent ? <AgentNetwork /> : <AdminNetwork />;
};

export default Network;
